import { Script } from 'gatsby';
import React, { useEffect } from 'react';
import EnvironmentUtils from '../../utils/environment.utils';
import { useAnalyticsConsent } from '../../hooks/use-analytics-consent';
import { GtagService } from '../../services/gtag/gtag.service';

const GoogleScripts: React.FC = () => {
    const { analyticsConsent, analyticsConsentRequired } = useAnalyticsConsent();

    useEffect(() => {
        if (analyticsConsent && analyticsConsentRequired) GtagService.updateConsent(analyticsConsent);
    }, [analyticsConsent, analyticsConsentRequired]);

    return EnvironmentUtils.isProd ? (
        <>
            <Script id="gtag-bootstrap">
                {`
                    window.dataLayer = window.dataLayer || [];
                    window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };
                    if (${analyticsConsentRequired}) {
                        var consentCookie = document.cookie.match(/(?:^|;\\s*)noblewillsAnalyticsConsent=([^;]*)/);
                        var storedConsent = consentCookie ? decodeURIComponent(consentCookie[1]) : '';
                        var storageConsent = storedConsent === 'accepted' ? 'granted' : 'denied';
                        window.gtag('consent', 'default', {
                            ad_storage: storageConsent,
                            ad_user_data: storageConsent,
                            ad_personalization: storageConsent,
                            analytics_storage: storageConsent,
                            wait_for_update: 500
                        });
                    }
                    (function (w, d, s, l, i) {
                        w[l] = w[l] || [];
                        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                        var f = d.getElementsByTagName(s)[0],
                            j = d.createElement(s),
                            dl = l != 'dataLayer' ? '&l=' + l : '';
                        j.async = true;
                        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                        f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', 'GTM-KC38BD8');
                `}
            </Script>
        </>
    ) : (
        <></>
    );
};

export default GoogleScripts;
